const divTableActions = {
  noResults: 'Ningún resultado encontrado',
  noAccountable: 'Sin responsable'
};

export default divTableActions;
